import {useOnMount} from 'shared/web';

import {pricedItemGroupStore} from '../utils/pricedItemGroupStore';

/**
 * Discards the group of a model year that is not published any more (unpublished here, or by
 * another author and read again): its bar is gone, so its changes could be neither confirmed nor
 * discarded, and a change of a draft year is written directly.
 */
export function DiscardUnpublishedGroup(props: {modelYearId: string}) {
  useOnMount(() => pricedItemGroupStore.discard(props.modelYearId));
  return null;
}
